import { EnterElement, ScaleLinear, Selection, axisLeft } from "d3"
import { MarginedBoundingBox } from "../../Types/MarginedBoundingBox"
import { D3OneToOneRenderable } from "./D3OneToOneRenderable"
import { ReactCallbacks } from "../../Types/ReactCallbacks"
import { MobergFontFamily, MobergFontSize } from "../../../../../../Moberg"
import { AXIS_TICK_FONT_SIZE } from "../Visualizations/Constants"

export type D3LinearYAxisConfig = {
    boundingBox: MarginedBoundingBox
    scale: ScaleLinear<any, any>
    label?: string
}

export class D3LinearYAxis extends D3OneToOneRenderable<SVGGElement, SVGGElement, D3LinearYAxisConfig> {
    private axisClassName: string = "d3-linear-y-axis"
    private labelClassName: string = "d3-linear-y-axis-label"
    private labelSpace = 30

    constructor(root: SVGGElement, config: D3LinearYAxisConfig, reactCallbacks: ReactCallbacks<any>) {
        super(root, config, "d3-linear-y-axis-root", reactCallbacks)
        this.render()
    }

    protected enter(newElements: Selection<EnterElement, D3LinearYAxisConfig, any, any>): Selection<SVGGElement, D3LinearYAxisConfig, SVGGElement, any> {
        // Create the Axis Group
        const axisGroup = newElements
            .append("g")
            .attr("class", this.className)
            .style("color", "var(--color-chart-axis-text)")

        const axis = axisLeft(this.config.scale).ticks(4)

        axisGroup.append("g")
            .attr("class", this.axisClassName)
            .call(axis)
            .style("user-select", "none") // disables highlighting the ticks
            .style("font-size", AXIS_TICK_FONT_SIZE)
            .style("font-family", MobergFontFamily.REGULAR)

        // create the label
        axisGroup.append("text")
            .attr("text-anchor", "middle")
            .attr("class", this.labelClassName)
            .attr("transform", `translate(${-this.labelSpace}, ${Math.round(this.config.scale.range()[0] / 2)}) rotate(-90)`)
            .text(() => this.config.label ?? "")
            .attr("fill", "var(--color-chart-axis-text)")


        return axisGroup
    }

    protected update(updatedElements: Selection<SVGGElement, D3LinearYAxisConfig, any, any>): Selection<SVGGElement, D3LinearYAxisConfig, SVGGElement, any> {
        const axisGroup = updatedElements

        // Redraw the axis
        const axis = axisLeft(this.config.scale).ticks(4)
        const d3Axis = axisGroup.select("." + this.axisClassName) as Selection<SVGGElement, any, any, any>
        d3Axis.call(axis)

        // Update the label
        axisGroup.select("." + this.labelClassName)
            .attr("transform", `translate(${-this.labelSpace}, ${Math.round(this.config.scale.range()[0] / 2)}) rotate(-90)`)
            .text(() => this.config.label ?? "")
            .style("font-size", MobergFontSize.LARGE)
            .style("font-family", MobergFontFamily.REGULAR)

        return updatedElements
    }
}
